export enum ToolNavigationItemType {
    Language = "language",
    Link = "link",
    Market = "market",
    Search = "search",
    Stockticker = "stockticker"
}